<script lang="ts">
  export let size: any = '22';
</script>

<svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M14.1667 2.02502H5.83335C3.33335 2.02502 1.66669 3.69169 1.66669 6.19169V11.1917C1.66669 13.6917 3.33335 15.3584 5.83335 15.3584H9.16669L12.875 17.825C13.425 18.1917 14.1667 17.8 14.1667 17.1334V15.3584C16.6667 15.3584 18.3334 13.6917 18.3334 11.1917V6.19169C18.3334 3.69169 16.6667 2.02502 14.1667 2.02502ZM12.9167 9.37502H7.08335C6.74169 9.37502 6.45835 9.09169 6.45835 8.75002C6.45835 8.40836 6.74169 8.12502 7.08335 8.12502H12.9167C13.2584 8.12502 13.5417 8.40836 13.5417 8.75002C13.5417 9.09169 13.2584 9.37502 12.9167 9.37502Z"
    class={$$props.class || "fill-blueish-grey-500"}
  />
</svg>
